import React from 'react';
import { FlaskConicalIcon } from 'lucide-react';
export function ExampleDataBadge() {
  return <span className="inline-flex items-center gap-1 rounded-sm border border-dashed border-sf-border-strong bg-white px-1.5 text-[11px] font-semibold leading-[18px] text-sf-weak" data-id="element-839" data-mp="jaoxddmfl84w">
      <FlaskConicalIcon className="h-3 w-3" aria-hidden="true" data-id="element-840" data-mp="9k45sa56d3vh" />
      Example data
    </span>;
}